// import React from 'react';
// import ReactDOM from 'react-dom';
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// ReactDOM.render(

//   <React.StrictMode>

//     <Router>
//       <Switch>
//         <Route path="/kamilkoc-flixbus-is-ortagi" component={App} />
//       </Switch>
//     </Router>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import App from './App';
import FlixRoute from './FlixRoute';

ReactDOM.render(
  <React.StrictMode>
    <FlixRoute />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
